/**
 * ItemDetail component
 * @returns <ItemDetail />
 */
import { useState } from "react";

import Badge from "./Badge";
import Button from "./Button";
import Select from "./Select";
import InputContainer from "./InputContainer";
import Description from "./Description";
import LegalInformation from "./LegalInformation";
import Tabs from "./Tabs";
import BookForm from "./BookForm";
import { formatPrice } from "../scripts/helpers/formatPrice";

const ItemDetailModelo = ({ item, financeOn }) => {
    const {
        title,
        detailSubtitle: subtitle,
        image,
        secondaryImage,
        description,
        legalInfo,
        inputs,
        price,
        green_tax,
        itemBookPrice,
        currency,
        extraInfo,
        id,
    } = item;

    const initialState = {
        id,
        title,
        image,
        description,
        currency,
        price,
        payment_type: "cash",
        totalPrice: null,
        dealership: null,
    };

    const [showBookForm, setShowBookForm] = useState(false);
    const [itemToAddToCart, setItemToAddToCart] = useState(initialState);

    const tabClickHandler = (value) => {
        setItemToAddToCart((prevState) => {
            return {
                ...prevState,
                payment_type: value,
                price: extraInfo["cash"].price,
            };
        });
    };

    const dealershipChangeHandler = (value) => {
        setItemToAddToCart((prevState) => {
            return {
                ...prevState,
                dealership: value,
            };
        });
    };

    const addToCartHandler = () => {
        setItemToAddToCart((prevState) => {
            return {
                ...prevState,
                totalPrice: prevState.price,
            };
        });
    };

    const toggleBookFormHandler = () => {
        addToCartHandler();
        setShowBookForm(!showBookForm);
    };

    return (
        <section className="item-detail">
            <div className="wrapper">
                <div className="item-detail__grid">
                    <div className="box-left">
                        <div className="title-container mobile-only">
                            {/* Out of stock */}
                            {item.stock ?
                                item.stock_warning ? 
                                    <Badge
                                        type="badge-card"
                                        text="¡Último disponible!"
                                        backgroundColor="#AD0B00"
                                    /> : 
                                    <Badge
                                        type="badge-card"
                                        text={`${item.stock} disponibles`}
                                        backgroundColor="#8A8D8F"
                                    />
                                : null
                            }

                            {/* Main title in desktop */}
                            <h1 className="title">
                                {showBookForm
                                    ? "¡Falta poco para que sea tuyo!"
                                    : title}
                            </h1>

                            {/* OPTIONAL: Subtitle */}
                            {subtitle && <p className="subtitle">{subtitle}</p>}
                        </div>

                        {/* Main image */}
                        <img
                            className="item-detail__image"
                            src={image}
                            alt=""
                        />

                        {/* OPTIONAL: Secondary image */}
                        {secondaryImage && (
                            <img
                                className="item-detail__image"
                                src={secondaryImage}
                                alt=""
                                />
                        )}

                        {/* OPTIONAL: Description */}
                        {description && (
                            <Description {...description} type={"car"} />
                        )}
                    </div>

                    <div className={"box-right --mantencion"}>
                        <div className="title-container desktop-only">
                        {item.stock ?
                            item.stock_warning ? 
                                <Badge
                                    type="badge-card"
                                    text="¡Último disponible!"
                                    backgroundColor="#AD0B00" 
                                /> : 
                                <Badge
                                    type="badge-card"
                                    text={`${item.stock} disponibles`}
                                    backgroundColor="#8A8D8F"
                                />
                            : null
                        }

                            {/* Main title in desktop */}
                            <h1 className="title">
                                {showBookForm
                                    ? "¡Falta poco para que sea tuyo!"
                                    : title}
                            </h1>

                            {/* OPTIONAL: Subtitle */}
                            {subtitle && !showBookForm && (
                                <p className="subtitle">{subtitle}</p>
                            )}
                        </div>

                        {!showBookForm && (
                            <>
                                {/* Precio Online */}
                                <InputContainer title={"Precio online"}>
                                    <Tabs
                                        model={title}
                                        cash={extraInfo.cash}
                                        clickHandler={tabClickHandler}
                                        item={item}
                                        financeOn={financeOn}
                                    />
                                    <p className="green-tax">+ Impuesto Verde ${green_tax}</p>
                                </InputContainer>

                                {/* Concesionario */}
                                <InputContainer
                                    title={"Concesionario"}
                                    subtitle={
                                        "Elige el concesionario dónde deseas hacer la reserva"
                                    }
                                    extraClass=""
                                >
                                    <Select
                                        {...inputs.dropdown}
                                        type={"select"}
                                        name={"concesionario"}
                                        label={"Concesionario"}
                                        placeholder={
                                            "Seleccionar un concesionario"
                                        }
                                        selectChangeHandler={
                                            dealershipChangeHandler
                                        }
                                    />
                                </InputContainer>

                                {/* Reservar */}
                                <InputContainer
                                    title={"Resérvalo"}
                                    subtitle={
                                        "¡No te lo pierdas, podes tenerlo ahora!."
                                    }
                                    extraClass="add-to-cart"
                                >
                                    <Button
                                        tag={"cart"}
                                        text={"Resérvalo con"}
                                        onClick={toggleBookFormHandler}
                                        currency={currency}
                                        totalPrice={formatPrice(itemBookPrice)}
                                        disabled={!itemToAddToCart.dealership}
                                    />
                                </InputContainer>
                            </>
                        )}

                        {showBookForm && (
                            <BookForm
                                totalPrice={itemBookPrice}
                                productId={itemToAddToCart.id}
                                dealershipId={itemToAddToCart.dealership}
                                payment_type={itemToAddToCart.payment_type}
                            />
                        )}
                    </div>
                </div>
            </div>

            <LegalInformation texts={legalInfo} />
        </section>
    );
};

export default ItemDetailModelo;
